import React, {useState} from "react";
import PortalLeftSection from "./PortalLeftSection/PortalLeftSection";
import Chart from "../../GlobalComponents/Chart/Chart";
import PortalRightSection from "./PortalRightSection/PortalRightSection";
import PortalBottom from "./PortalBottom/PortalBottom";
import NavLayout from "../../GlobalComponents/NavLayout/NavLayout";
import { common, privateNav } from "../../utils/navItems";
import Footer from "../../GlobalComponents/Footer/Footer";
import ConnectButton from "../../GlobalComponents/ConnectButton/ConnectButton";

const Portal = () => {
  const [address, setAddress] = useState("");
  return (
    <div>
      <NavLayout
        navItems={privateNav}
        setAddress={setAddress}
        buttons={
          <div className="button-container xl:gap-[27px]">
            <button className=" text-res-xs h-10 w-[120px] border border-solid border-main-green font-normal leading-[19px]">
              <span>R34P</span>
              <span className="font-black"> $36.65</span>
            </button>
            <ConnectButton text={"Connect Wallet"}></ConnectButton>
          </div>
        }
      ></NavLayout>
      <div className="mx-auto max-w-[1440px] md:px-0 px-2">
        <div className="mx-auto max-w-[1410px] md:px-0 px-2">
          <div className="mt-[80px] ">
            <h2 className="text-res-xl text-center font-bold mb-[50px] md:mb-[100px]">
              <span className="text-main-green">Forex’s</span> Portal
            </h2>
          </div>
          <div className="flex xl:flex-row flex-col gap-[10px]">
            <div className="w-full xl:min-w-[780px] xl:max-w-[780px]">
              <PortalLeftSection></PortalLeftSection>
            </div>
            <div className="grow">
              <PortalRightSection></PortalRightSection>
            </div>
          </div>
        </div>
      </div>
      <div className="max-w-[1416px] mx-auto">
        <div className="mt-[116px]">
          <PortalBottom></PortalBottom>
        </div>
      </div>
      <div className="mt-10">
        <Footer></Footer>
      </div>
    </div>
  );
};

export default Portal;
